import React, { useCallback, useMemo } from "react";
import { Rejoin, Sitout } from "../../common/game/GameControl";
import { useSelector } from "react-redux";

const SitOutButton = () => {
  const gameState = useSelector((state) => state.gameState);
  const user = useSelector((state) => state.auth.user);

  const currentIndex = useMemo(
    () => gameState.ActivePlayers.findIndex((x) => x.PlayerId === user.Id),
    [gameState.ActivePlayers, user.Id]
  );

  const currentPlayer = useMemo(() => {
    if (currentIndex === -1) return {};
    return gameState.ActivePlayers[currentIndex];
  }, [currentIndex, gameState.ActivePlayers]);

  const SitOutEventHandler = useCallback(
    async (ev) => {
      // DC-FE-SITOUT-REMOVE-LOCAL-DISPATCH-003: Call API only, state updated via SignalR "Sitout" event
      Sitout(user.Id, gameState.GameCode, currentIndex);
    },
    [currentIndex, gameState, user.Id]
  );

  const RejoinEventHandler = useCallback(
    async (ev) => {
      // DC-FE-REJOIN-REMOVE-LOCAL-DISPATCH-001: Call API only, state updated via SignalR "Rejoin" event
      Rejoin(user.Id, gameState.GameCode, currentIndex);
    },
    [currentIndex, gameState, user.Id]
  );

  // Show message when player has rejoined but is still folded (waiting for next hand)
  const isWaitingForNextHand = !currentPlayer.IsSitOut && currentPlayer.IsFolded;

  return (
    <>
      {isWaitingForNextHand && (
        <div className="alert alert-info py-1 px-2 mb-2" role="alert">
          You'll rejoin at the start of the next hand.
        </div>
      )}
      {currentPlayer.IsSitOut ? (
        <button
          className="btn btn-primary BtnRejoin"
          onClick={RejoinEventHandler}
        >
          Rejoin
        </button>
      ) : (
        <button
          className="btn btn-primary BtnSitOut me-2 mt-2"
          onClick={SitOutEventHandler}
        >
          Sit Out
        </button>
      )}
    </>
  );
};

export default SitOutButton;
